import { render, staticRenderFns } from "./Hiring.vue?vue&type=template&id=0bb08357&scoped=true&"
import script from "./Hiring.vue?vue&type=script&lang=js&"
export * from "./Hiring.vue?vue&type=script&lang=js&"
import style0 from "./Hiring.vue?vue&type=style&index=0&id=0bb08357&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb08357",
  null
  
)

export default component.exports